import { memo, type PropsWithChildren, useCallback, useState } from "react"

import { LocationPickerOverlay } from "../../components/Overlays/LocationPickerOverlay"
import { LocationPickerContext } from "./context"
import type { LocationPickerConfig } from "./typings"

interface LocationPickerProviderProps extends PropsWithChildren {
	onOpenChange?: (open: boolean) => void
}

export const LocationPickerProvider = memo<LocationPickerProviderProps>((props) => {
	const { children, onOpenChange } = props
	const [config, setConfig] = useState<LocationPickerConfig | null>(null)

	const closeLocationPicker = useCallback(() => {
		setConfig(null)
		onOpenChange?.(false)
	}, [onOpenChange])

	const openLocationPicker = useCallback(
		(func: (closeLocationPicker: () => void) => LocationPickerConfig) => {
			setConfig(func(closeLocationPicker))
			onOpenChange?.(true)
		},
		[closeLocationPicker, onOpenChange],
	)

	return (
		<LocationPickerContext value={openLocationPicker}>
			{children}
			{config && <LocationPickerOverlay onConfirm={config.onConfirm} onCancel={config.onCancel} />}
		</LocationPickerContext>
	)
})
LocationPickerProvider.displayName = "LocationPickerProvider"
